import AttachmentField from './AttachmentField'
import { useFormikContext } from 'formik'
import { AttachmentS3, IProductWarrantyClaim } from '@cbgms/api'

const AttachmentFields = () => {
  const { values: formValues } = useFormikContext<IProductWarrantyClaim>()

  if (!formValues?.AttachmentsS3Internal || !formValues?.AttachmentsS3Internal?.length) {
    return null
  }

  return (
    <>
      {formValues.AttachmentsS3Internal.map((attachment: AttachmentS3, index: number) => (
        <AttachmentField key={index} file={attachment} index={index} />
      ))}
    </>
  )
}

export default AttachmentFields
